import { SelectOption } from '@globaleris/ui.library'
import { Dispatch } from '../../api'
import { EnumEstadoViajeOpLogistica } from '../../api/oData/enums/enumEstadoViajeOpLogistica'
import {
  apiDeleteTank,
  apifetchCarriers,
  apifetchClients,
  apiFetchCostTypes,
  apifetchDestinations,
  apifetchOriginPlants,
  apiFetchQuantityElements,
  apiFetchTankOpsToDispatch,
  apifetchTankTravel,
  apiOpsInActiveDispatch,
  apiTankCancel,
  apiTanksAdd,
  apiTanksGET,
  apiTanksLastHundredGET,
  apiTankUpdate,
  postTankSend,
  apiTanksForUserGET,
  apiTanksGETByManagedState,
  apiFetchDefaultCosts
} from '../../api/Pioneer/endpoints/tanks/tanks.api'
import Tanks from '../../api/Pioneer/model/Tanks'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import {
  defaultCostsMapper,
  getOpsIds,
  getTanksIds,
  listCarriertemMapper,
  mapCostTypesList,
  mapGetCarriers,
  mapGetClients,
  mapGetOriginPlants,
  mapGetTanksSize,
  sendMassiveDispatchesMapper,
  tankShipmentMapper,
  tankShipmentMapperPatch,
  tanksListItemMapper,
  tanksListItemsMapper
} from './tanks.mapper'
import {
  CarrierTableModel,
  DataFormModel,
  DefaultCosts,
  DestinationTableModel,
  TankModel,
  TankModelPatch
} from './tanks.model'

export type FetchTanksParams = {
  startDate?: Date
  endDate?: Date
  clientID?: number
  lastHundredTanks?: boolean | null
}

export type FetchTanksForUserParams = Omit<FetchTanksParams, 'clientID'> & {
}

export const fetchTanksListItems = async ({
  startDate,
  endDate,
  clientID,
  lastHundredTanks = false
}: FetchTanksParams): Promise<ServiceResponse<TankModel[] | undefined>> => {
  if (lastHundredTanks){
    return apiTanksLastHundredGET(clientID)
    .then(response => {
      return createSuccessServiceResponse(tanksListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
  } else {
    return apiTanksGET(startDate, endDate, clientID)
    .then(response => {
      return createSuccessServiceResponse(tanksListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
  }
}

// Se utiliza para usuarios con rol "gestionados y no gestionados"
export const fetchTanksListItemsForUser = async ({
  startDate,
  endDate,
  lastHundredTanks = false
}: FetchTanksForUserParams): Promise<ServiceResponse<TankModel[] | undefined>> => {
  return apiTanksForUserGET({ startDate, endDate, lastHundredTanks })
    .then(response => {
      return createSuccessServiceResponse(tanksListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTanksListItemsByRegisteredState = async (): Promise<
  ServiceResponse<TankModel[] | undefined>
> => {
  // Se utiliza para usuarios con rol "TPA". El API busca estados Registrado y Pendiente únicamente.
  return await apiTanksGETByManagedState(EnumEstadoViajeOpLogistica.Registrado)
    .then(response => {
      return createSuccessServiceResponse(tanksListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTanksListItemsByValidatedState = async (): Promise<
  ServiceResponse<TankModel[] | undefined>
> => {
  // Se utiliza para usuarios con rol "TPA". El API busca estado Validado únicamente.
  return await apiTanksGETByManagedState(EnumEstadoViajeOpLogistica.Validado)
    .then(response => {
      return createSuccessServiceResponse(tanksListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchCarriers = async (): Promise<ServiceResponse<any>> => {
  return apifetchCarriers()
    .then(response => {
      return createSuccessServiceResponse(listCarriertemMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// export const sendTanks = async (rows: any[]): Promise<any> => {
//   return await apiTankSend(rows)
//     .then(response => {
//       return createSuccessServiceResponse(response)
//     })
//     .catch(error => {
//       return createErrorServiceResponse(error)
//     })
// }

export const sendTanksMassive = async (
  items: any[]
): Promise<ServiceResponse<Dispatch[] | undefined>> => {
  return await postTankSend(sendMassiveDispatchesMapper(items))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      console.log('dispatchMassive error', error)
      return createErrorServiceResponse(error)
    })
}

export const fetchTankOpsToDispatch = async (
  items: any[]
): Promise<ServiceResponse<any[] | undefined>> => {
  return await apiFetchTankOpsToDispatch(getTanksIds(items))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      console.log('fetchTankOpsToDispatch error', error)
      return createErrorServiceResponse(error)
    })
}

export const fetchOpsInActiveDispatch = async (
  items: any[]
): Promise<ServiceResponse<any[] | undefined>> => {
  return await apiOpsInActiveDispatch(getOpsIds(items))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      console.log('fetchOpsInActiveDispatch error', error)
      return createErrorServiceResponse(error)
    })
}

//#retries

export const checkTanksState = async (
  TanksIds: number[],
  desiredStates: EnumEstadoViajeOpLogistica[]
): Promise<TankModel[]> => {
  return await apifetchTankTravel(TanksIds).then(response => {
    let updatedTanks: TankModel[] = []
    response.forEach(tank => {
      if (desiredStates.some(x => x === tank.tankOperation)) {
        updatedTanks.push(tanksListItemMapper(tank))
      }
    })
    return updatedTanks
  })
  return []
}

//#endregion

//#region TANKS ADD

export const fetchGetTanksSize = async (): Promise<SelectOption[]> => {
  return await apiFetchQuantityElements()
    .then(response => {
      return mapGetTanksSize(response)
    })
    .catch(error => {
      return [] //createErrorServiceResponse(error);
    })
}

export const fetchDestinations = async (
  relatedDestinationsIds,
  clientId,
  originPlantId
): Promise<ServiceResponse<SelectOption[] | undefined>> => {
  return await apifetchDestinations(relatedDestinationsIds, clientId, originPlantId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchOriginPlants = async (
  destinations?: number[],
  clientId?: number
): Promise<ServiceResponse<SelectOption[] | undefined>> => {
  return await apifetchOriginPlants(destinations, clientId)
    .then(response => {
      return createSuccessServiceResponse(mapGetOriginPlants(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchCarriersAdd = async (): Promise<SelectOption[]> => {
  return await apifetchCarriers()
    .then(response => {
      return mapGetCarriers(response)
    })
    .catch(error => {
      return [] //createErrorServiceResponse(error);
    })
}
export const fetchClients = async (): Promise<SelectOption[]> => {
  return await apifetchClients()
    .then(response => {
      return mapGetClients(response)
    })
    .catch(error => {
      return [] //createErrorServiceResponse(error);
    })
}

export const fetchCostTypes = async (): Promise<SelectOption[]> => {
  return await apiFetchCostTypes()
    .then(response => {
      return mapCostTypesList(response)
    })
    .catch(error => {
      return [] //createErrorServiceResponse(error);
    })
}

//#endregion

//#region TANKS EDIT

export const addTanks = async (
  formData: DataFormModel,
  destinationData: DestinationTableModel[],
  carriersData: CarrierTableModel[], 
  newState?: EnumEstadoViajeOpLogistica
): Promise<ServiceResponse<any>> => {
  return await apiTanksAdd(tankShipmentMapper(formData, destinationData, carriersData, null, newState))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateTank = async (
  tank: any,
  formData: DataFormModel,
  destinationData: DestinationTableModel[],
  carriersData: CarrierTableModel[],
  newState?: EnumEstadoViajeOpLogistica
): Promise<ServiceResponse<any>> => {
  return await apiTankUpdate(
    tankShipmentMapper(formData, destinationData, carriersData, tank, newState)
  )
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const editTank = async (
  tank: any,
  patchData: TankModelPatch
): Promise<ServiceResponse<any>> => {
  return await apiTankUpdate(tankShipmentMapperPatch(tank, patchData))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTankTravel = async (
  travelId: number
): Promise<ServiceResponse<Tanks[] | undefined>> => {
  return await apifetchTankTravel([travelId])
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchDefaultCosts = async (tankDate?: string): Promise<ServiceResponse<DefaultCosts[] | undefined>> => {
  
  return await apiFetchDefaultCosts(tankDate)
    .then(response => {
      return createSuccessServiceResponse(defaultCostsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const cancelTanks = async (rows: any[]): Promise<any> => {
  return await apiTankCancel(rows)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteTank = async (tankId: number): Promise<any> => {
  return await apiDeleteTank(tankId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
